module.exports = __webpack_public_path__ + "static/media/greenBackground.9df3b902.png";